import type { DashboardData } from "./types";

export const preserveDashboardIdentity = (current: DashboardData | null, next: DashboardData): DashboardData => {
  if (next.identity || !current?.identity) return next;
  return { ...next, identity: current.identity };
};
